module.exports = __webpack_public_path__ + "img/invitation-to-register-for-portal-th.08dfd97.png";